










import {
    defineComponent,
    computed,
    toRefs,
    PropType,
    Ref,
    ref,
    onMounted,
    reactive,
} from '@vue/composition-api';
interface StepsTextType {
    title: string;
    description: string;
}

export default defineComponent({
    props: {
        active: {
            type: Number,
            default: -1,
        },
        stepsText: {
            type: Array as PropType<Array<StepsTextType>>,
            default: () => {
                return [];
            },
        },
    },
    setup() {},
});
